<input type="file" multiple (change)="onFileSelected($event)" #fileUpload hidden />
<div [style.margin-bottom.em]="1">
  <div>
    <button
      mat-raised-button
      color="primary"
      (click)="fileUpload.click()"
      [disabled]="busy"
      [disabled]="readonly"
      type="button"
      [matTooltip]="tooltip"
    >
      <mat-icon>attach_file</mat-icon><span [innerText]="'crud.file.attach' | translate"></span>
    </button>
  </div>
  <div class="d-flex flex-column">
    <button
      type="button"
      mat-raised-button
      color="accent"
      (click)="uploadFiles()"
      [disabled]="busy || typedFiles.value.length <= 0"
    >
      <mat-icon>upload</mat-icon> <span [innerText]="'crud.file.upload' | translate"></span>
    </button>
    @if (!form.valid && form.touched) {
      <mat-error>
        <span [innerHtml]="'crud.fileUpload.error.missingRequiredFields' | translate"></span>
      </mat-error>
    }
  </div>
</div>
<div class="fill d-flex flex-column gap-16" [formGroup]="form">
  <ng-container formArrayName="typedFiles">
    @for (typedFileForm of typedFiles.controls; track typedFileForm; let i = $index) {
      <mat-card
        appearance="outlined"
        [formGroup]="castToFormGroup(typedFileForm)"
        class="mat-card-attach"
      >
        <div [style.padding-top.em]="1" class="break-all">
          {{ typedFileForm.value.file.name }}
        </div>
        @if (documentTypes) {
          <mat-form-field>
            <mat-label>Dokument Type</mat-label>
            <mat-select
              ngDefaultControl
              formControlName="documentTypeId"
              [required]="typeIsRequired"
            >
              @for (docType of documentTypes; track docType) {
                <mat-option [value]="docType.value" [title]="docType.label">
                  {{ docType.label }}
                </mat-option>
              }
            </mat-select>
            @if (typeIsRequired) {
              <mat-error>
                <span [innerHtml]="'crud.fileUpload.error.required' | translate"></span>
              </mat-error>
            }
          </mat-form-field>
        }
        <div [style.padding-top.em]="0.5">
          <button mat-button color="warn" (click)="detachFile(i)" [disabled]="busy">
            <mat-icon>clear</mat-icon>
          </button>
        </div>
      </mat-card>
    }
  </ng-container>
</div>

<spinner-overlay [show]="busy"></spinner-overlay>
